import React, { useState, useEffect } from "react";
import "./pgmlist.scss";
import Sidebar from "../Sidebar";
import { pgmlist3wAction } from "../../actions/pgmlistAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { decode, encode } from "base-64";
import Header from "../../component/loaderComponent/Header/Header";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Nopermission from "../../component/loaderComponent/NoPermissions/Nopermission";
import Cookies from "js-cookie";
import { notify } from '../../services/notification';
import Validation from "../../constants/validation/Validation";
import { useSelector } from "react-redux";
import { categoryAction, pgmpageAction, toggleUserStatusAction } from "../../actions/pgmlistAction";
import { searchCriteriaAction } from "../../actions/pgmlistAction";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { dowloadpgmlist3wAction } from "../../actions/exceldownloadAction";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { constant } from "../../constants/constant";
import { calculatePageCount } from "../../constants/constant";
import { HTTP_STATUS } from "../../constants/httpsStatus/httpsStatus";
import useMobileView from "../../constants/useMobileView";
import { HiMenu, HiX } from "react-icons/hi";



function PgmlistThreeWheeler(props) {

  const [state, setDataState] = useState({
    pgmdata: [],

  });

  const searchdata = useSelector((state) => state.pgmSearch);
  const [states, setDataStates] = useState({
    nameValue: searchdata?.searchdata?.data?.value,
    criteriaKey: ""
  })
  const [count, setCount] = useState(constant.defaultPage);
  const { isSidebarOpen, toggleSidebar } = useMobileView();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [criteria, setcriteria] = useState(searchdata?.searchdata?.data?.criteria ? searchdata?.searchdata?.data?.criteria : "");
  const [isLoading, setLoading] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [paginationListcount, setpaginationListcount] = useState(0);
  const data = decode(Cookies.get('permissions'));
  const permissions = data?.includes("pgm_registration_approval");

  const [allApiParams, setAllApiParams] = useState({
    user_type: "pgm_3w",
    page: constant.defaultPage,
    page_size: constant.paginationCount,
    is_active: null,
    endPoint: "all"
  })
  const [apiCriteria, setapiCriteria] = useState({})

  const handleParamChanges = (key, value) => {
    setAllApiParams((prev) => ({
      ...prev,
      [key]: value
    }));
  }

  const queryString = (param) => {
    const filterParam = Object.fromEntries(Object.entries(param).filter(([_, value]) => value !== null && value !== "" && value !== 0))
    const queryStr = new URLSearchParams(filterParam).toString()
    return queryStr
  }

  const getData = () => {
    const { endPoint, ...newApiParams } = allApiParams
    const query = queryString({ ...newApiParams, ...apiCriteria })
    PgmListData(query);
  }

  useEffect(() => {
    if (states?.nameValue == "") {
      getData()
    }
  }, [apiCriteria])

  useEffect(() => {
    getData()
  }, [allApiParams]);

  async function handleCriteriaChange(event) {
    setDataStates({
      ...states,
      nameValue: '',
      criteriaKey: event.target.value
    });

    setAllApiParams((prev) => ({
      ...prev,
      page: constant.defaultPage
    }))
    setapiCriteria({})

    setcriteria(event.target.value);
  }


  const handleChange = (evt) => {
    const { name, value } = evt.target;
    const trimmedValue = value.trimStart(); // Remove leading spaces
    setDataStates((prevStates) => ({
      ...prevStates,
      [name]: trimmedValue,
    }));
    if (trimmedValue.length === "") {
      setLoading(true);
      setcriteria('');
      setTimeout(() => setLoading(false), 500); // Ensures the loader turns off after a short time
    } else {
      setLoading(false);
    }
    if (value.length === 0) {
      window.location.reload()
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      filterSearch();
    }
  }

  const pgmDetails = (Id) => {
    window.scroll(0, 0);
    const encodeid = encode(Id);
    navigate(`/3w/pgmdetails/${encodeid}`);
  };


  const handleClick = (para, isActive) => {
    setAllApiParams((prev) => ({
      ...prev,
      is_active: isActive,
      endPoint: para,
      page: constant.defaultPage
    }));

    setcriteria('')
    setapiCriteria({})
    setDataStates({
      ...states,
      nameValue: ''
    });
  };

  async function PgmListData(queryString) {
    setLoading(true);
    var response = await dispatch(pgmlist3wAction(queryString));
    if (response == HTTP_STATUS.SUCCESS || response != null) {
      setLoading(false);
      setNodata(true);
      const totalPageCount = calculatePageCount(response.data.count, constant.paginationCount);
      setCount(totalPageCount);
      setDataState({
        pgmdata: response.data.results.data,
      });
      setpaginationListcount(response.data.count)
    }
  }
  const startItem = state?.pgmdata?.length === 0 ? 0 : (allApiParams.page - constant.defaultPage) * constant.paginationCount + constant.defaultPage;
  const endItem = Math.min(allApiParams.page * constant.paginationCount, paginationListcount);

  const handlePaginationChange = (event, value) => {
    handleParamChanges("page", value)
  };
  async function filterSearch() {

    if (criteria === '') {
      notify.error('Please select Criteria .')
      return false
    }
    var seardata = {
      criteria: criteria,
      value: states.nameValue,
    };
    dispatch(searchCriteriaAction(seardata));

    let newParam = {
      ...allApiParams,
      page: constant.defaultPage,
      [criteria]: states.nameValue
    }

    setAllApiParams((prev) => ({
      ...prev,
      page: constant.defaultPage,
    }))

    setapiCriteria({
      [criteria]: states.nameValue
    })

    const { endPoint, ...newApiParams } = newParam
    const query = queryString(newApiParams)
    PgmListData(query)
  }
  async function downloadpgmlist() {
    try {
      const fileBlob = await dispatch(dowloadpgmlist3wAction(allApiParams.page, allApiParams.endPoint, allApiParams.is_active, states.nameValue, criteria));

      if (fileBlob) {
        const blobUrl = URL.createObjectURL(fileBlob);
        const newWindow = window.open(blobUrl, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          notify.error('Popup blocked. Please allow popups for this website');
        }
      }
    } catch (error) {
      notify.error('Error downloading file:', error);
    }
  }

  const handleStatusChange = async (id, isActive) => {
    try {
      const payload = { id, is_active: isActive };
      const response = await dispatch(toggleUserStatusAction(id, payload));

      if (response.status === HTTP_STATUS.SUCCESS) {
        notify.success(response?.data?.message);
        dispatch(pgmpageAction(constant.defaultPage));
        setTimeout(() => {
          getData()
        }, 800);
      }
    } catch (error) {
      notify.error("Error updating status");
    }
  };

  return (
    <div className="pgm-list-3w">
      <div className="PgmConatiner">
        <div className="pgmlistcontainer">
          <div className="pgm_list_container_s">
            <Header title="PGM List" />
            {isLoading ? (
              <Loader />
            ) : (
              <>
                {permissions === true ?
                  <div className="Pgmmargin_div">
                    <div className="pgmbutton">
                      <div className="button-group-pgmlist">
                        <button className={allApiParams.endPoint === "all" ? "active" : ""} onClick={() => handleClick("all", null)} > All </button>
                        <button className={allApiParams.endPoint === "Approved" && allApiParams.is_active === true ? "active" : ""} onClick={() => handleClick("Approved", true)}> Active </button>
                        <button className={allApiParams.endPoint === "Approved" && allApiParams.is_active === false ? "active" : ""} onClick={() => handleClick("Approved", false)}> InActive </button>
                      </div>
                      <button className="download_excel" onClick={downloadpgmlist}>
                        <img src={Image_Url.EXCEL_LOGO} className="downloads_imgdexcel" />
                        Download Excel
                      </button>
                    </div>
                    <div className="textfield_dropdown">
                      <select
                        name="criteria"
                        className="text_fileddropdowns"
                        value={criteria}
                        onChange={handleCriteriaChange}
                      >
                        <option value="">Select Criteria</option>
                        <option value="name">PGM Name</option>
                        <option value="dealer_name">Dealer Name</option>
                        <option value="garage_name">Shop Name</option>
                        <option value="district_name">Location</option>
                        <option value="dealer_id"> Dealer ID</option>
                      </select>

                      <input
                        type="search"
                        className="input_Text_EnterValue"
                        placeholder="Enter a Value"
                        name="nameValue"
                        maxLength={criteria === "pincode" ? 6 : criteria === "mobile_number" ? constant.paginationCount : 100}
                        value={states.nameValue}
                        disabled={!criteria}
                        onChange={handleChange}
                        onKeyPress={(e) =>
                          ["pincode", "mobile_number"].includes(criteria) &&
                          Validation.numberinputValidator(e)
                        }
                        onKeyDown={handleKeyDown}
                      />

                      <button
                        className="pgm_buttonsearchs"
                        disabled={!criteria || !states.nameValue}
                        onClick={filterSearch}
                      >
                        Search
                      </button>
                    </div>
                    <div className="tabledata">
                      {state.pgmdata?.length > 0 ?
                        <div className="pgm-table-data">
                          <table className="table">
                            <tr>
                              <th className="tablesth">PGM ID</th>
                              <th className="tablesth">PGM Name</th>
                              <th className="tablesth">Mobile No.</th>
                              <th className="tablesth">Shop Name</th>
                              <th className="tablesth">Location</th>
                              <th className="tablesth">Dealer ID</th>
                              <th className="tablesth">Dealer Name</th>
                              <th className="tablesth">Active/Inactive</th>
                            </tr>
                            {state.pgmdata?.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td className="tabletd-pgmlist" key={index}>{item?.id}</td>
                                  <td className="tabletd-pgmlist" key={index}>{item?.name}</td>
                                  <td className="tabletd-pgmlist" key={index}>{`(${item?.mobile_code})-${item?.mobile_number}`}</td>
                                  <td className="tabletd-pgmlist shop-name" title={item?.garage_name}>{item?.garage_name}</td>
                                  <td className="tabletd-pgmlist">{item?.district_name}</td>
                                  <td className="tabletd-pgmlist-mobile">
                                    {item?.dealers?.map((dealer) => (
                                      <div key={dealer?.dealer_id}>
                                        {dealer?.dealer_id}
                                      </div>
                                    ))}
                                  </td>
                                  <td className="tabletd-pgmlist" key={index}>{item?.dealers?.map((dealer) => (
                                    <div key={dealer?.dealer_id}>
                                      {dealer?.dealer_name}
                                    </div>
                                  ))}</td>
                                  <td className="tabletdV">
                                    <div className="card_profile_controls">
                                      <div
                                        className="btn view_text"
                                        onClick={() => { pgmDetails(item.id) }}
                                      >
                                        View
                                      </div>
                                      <div>
                                        <label className="switch">
                                          <input type="checkbox" checked={item.is_active} onChange={() => handleStatusChange(item.id, !item.is_active)} />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </table>
                        </div>
                        :
                        <div>
                          {nodata && (<NoDataFound />)}
                        </div>
                      }

                      <div className="Pagination_section">
                        <Stack spacing={2}>
                          <Pagination
                            count={count}
                            className="pagination"
                            page={allApiParams.page}
                            size="medium"
                            defaultPage={constant.defaultPage}
                            color="primary"
                            onChange={handlePaginationChange}
                          />
                        </Stack>
                        <div className="count">
                          <b>
                            <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                  : (
                    <Nopermission />
                  )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default PgmlistThreeWheeler;
